// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generateReportModal .MuiPaper-root.MuiDialog-paper {
    width: 800px;
    max-width: 800px;
    border-radius: 16px;
    height: 460px;
}

.reconGenerateReportContainer {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    padding: 24px 24px 0px 24px;
}

.reconGenerateReportBody {
    height: 300px;
    overflow-y: scroll;
    padding: 0px 24px;
}

.reconFormClass {
    width: 100%;
}

.reconFormClassMargin {
    margin-top: 2rem;
}

.textField {
    border-radius: 8px;
    width: 100% !important;
    height: 42px;
    margin-top: 8px !important;
}

.selectField {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    margin-right: 12px;
    color: var(--character-title-85, rgba(0, 0, 0, 0.85));
    border-radius: 8px;
    width: 100% !important;
    margin-top: 8px !important;
}

.flexInputContainer {
    /* display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem; */
    display: grid;
    gap: 4%;
    grid-template-columns: 48% 48%;

}

.flexInputContainerMargin {
    margin-top: 2rem;
}

.dateTimeModalGenerateReport {
    width: auto;
    border-radius: 16px;
    height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Reconciliation/generateReportModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI;;;gBAGY;IACZ,aAAa;IACb,OAAO;IACP,8BAA8B;;AAElC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".generateReportModal .MuiPaper-root.MuiDialog-paper {\n    width: 800px;\n    max-width: 800px;\n    border-radius: 16px;\n    height: 460px;\n}\n\n.reconGenerateReportContainer {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 6px;\n    padding: 24px 24px 0px 24px;\n}\n\n.reconGenerateReportBody {\n    height: 300px;\n    overflow-y: scroll;\n    padding: 0px 24px;\n}\n\n.reconFormClass {\n    width: 100%;\n}\n\n.reconFormClassMargin {\n    margin-top: 2rem;\n}\n\n.textField {\n    border-radius: 8px;\n    width: 100% !important;\n    height: 42px;\n    margin-top: 8px !important;\n}\n\n.selectField {\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 400;\n    margin-right: 12px;\n    color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n    border-radius: 8px;\n    width: 100% !important;\n    margin-top: 8px !important;\n}\n\n.flexInputContainer {\n    /* display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 2rem; */\n    display: grid;\n    gap: 4%;\n    grid-template-columns: 48% 48%;\n\n}\n\n.flexInputContainerMargin {\n    margin-top: 2rem;\n}\n\n.dateTimeModalGenerateReport {\n    width: auto;\n    border-radius: 16px;\n    height: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
